import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';

const CreateBlobService = ComposedComponent =>
  reduxFetch([
    {
      resource: 'createBlob',
      method: 'post',
      request: (communityTag, callback, body) => ({
        url: apiRoutes.blobs(communityTag),
        body,
        meta: { callback },
      }),
    },
  ])(ComposedComponent);

export default CreateBlobService;
